exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/charts-and-summary/charts-and-summary.component.scss
// module id = ../../../../../src/app/components/dashboards/charts-and-summary/charts-and-summary.component.scss
// module chunks = main